import { Offer } from '../types'

type SortOrder = 'asc' | 'desc'

export function orderArray<T>(arr1: T[], arr2: T[], prop: keyof T, order: SortOrder = 'asc'): T[] {
  const direction = order === 'desc' ? -1 : 1
  return [...arr1, ...arr2].sort((item1, item2) => {
    if (item1[prop] < item2[prop]) return -1 * direction
    if (item1[prop] > item2[prop]) return 1 * direction
    return 0
  })
}

export const transformOfferIntoBeatLikeObject = (offer: Offer) => {
  return {
    ...offer, //fields that are offer specific, adding here for visibility
    image_url: offer.image_url,
    guid: offer.guid,
    created_at: offer.created_at,
    dismissed_at: offer.dismissed_at,
    active_at: offer.campaign_activated_at,
    displayed_at: offer.has_been_viewed,
    post_message_secondary: offer.pulse_post_message_secondary, //offer fields mapped to beat fields for functionality
    title: offer.pulse_title || offer.campaign_name,
    html_title: offer.pulse_title || offer.campaign_name,
    short_title: offer.pulse_title || offer.campaign_name,
    html_short_title: offer.pulse_title || offer.campaign_name,
    micro_title: offer.pulse_title || offer.campaign_name,
    html_micro_title: offer.pulse_title || offer.campaign_name,
    supporting_action: offer.pulse_call_to_action_text_secondary,
    description: offer.pulse_body,
    html_description: offer.pulse_body,
    micro_description: offer.pulse_body,
    html_micro_description: offer.pulse_body,
    call_to_action: offer.pulse_call_to_action_text,
    html_micro_call_to_action: offer.pulse_call_to_action_text,
    micro_call_to_action: offer.pulse_call_to_action_text,
    is_dismissed: offer.has_been_dismissed,
    icon_type: 5,
    template: 'MarketingOffer',
    //beat fields we null out
    account_guids: [],
    data_series: {},
    has_been_displayed: false,
    is_obsolete: false,
    is_refreshable: false,
    is_sampled: false,
    merchant_guids: [],
    payload: {},
    pulse_campaign_name: offer.campaign_name,
    scheduled_payment_guids: [],
    transaction_guids: [],
    user_guid: '',
    user_verification: 0,
  }
}
